const RECAPTCHA_STYLE_ERROR =
    /Cannot read propert(?:y|ies) of null \(reading 'style'\)/

let recaptchaErrorGuardInstalled = false

const isRecaptchaStyleError = (message, filename = '', stack = '') => {
    const text = `${message || ''} ${stack || ''}`
    const source = `${filename || ''} ${stack || ''}`

    return (
        RECAPTCHA_STYLE_ERROR.test(text) &&
        (/recaptcha/i.test(source) || /gstatic\.com/i.test(source) || /recaptcha/i.test(text))
    )
}

/**
 * Firebase invisible reCAPTCHA throws a known harmless error while cleaning up its DOM.
 * That uncaught error surfaces as CRA's red overlay and breaks the register UX.
 */
export const installRecaptchaErrorGuard = () => {
    if (typeof window === 'undefined' || recaptchaErrorGuardInstalled) {
        return
    }

    recaptchaErrorGuardInstalled = true

    window.addEventListener(
        'error',
        (event) => {
            const { message, filename, error } = event

            if (isRecaptchaStyleError(message, filename, error?.stack || message)) {
                event.preventDefault()
                event.stopImmediatePropagation()
            }
        },
        true
    )

    window.addEventListener(
        'unhandledrejection',
        (event) => {
            const { reason } = event
            const message = reason?.message || String(reason || '')
            const stack = reason?.stack || ''

            if (isRecaptchaStyleError(message, '', stack)) {
                event.preventDefault()
                event.stopImmediatePropagation()
            }
        },
        true
    )
}

export const ensureRecaptchaContainer = () => {
    if (typeof document === 'undefined') {
        return null
    }

    let container = document.getElementById('recaptcha-container')

    if (!container) {
        container = document.createElement('div')
        container.id = 'recaptcha-container'
        container.style.display = 'none'
        document.body.appendChild(container)
    }

    return container
}
